import { get, postJson, post } from '@/api/request/CommonRequest'
import axios from 'axios'
import { Message, Modal } from 'view-design'
import qs from 'qs'

export let sqlBaseApi = {}

sqlBaseApi.query = function (params) {
    return postJson('/nnhouse/query', params)
}

sqlBaseApi.insert = function (params) {
    return postJson('/nnhouse/insert', params)
}

sqlBaseApi.update = function (params) {
    return postJson('/nnhouse/update', params)
}

sqlBaseApi.delete = function (params) {
    return postJson('/nnhouse/delete', params)
}

sqlBaseApi.submitForm = function (params) {
    return postJson('/nnhouse/submitForm', params)
}